import React from 'react'

const SeedProduction = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Seed Production</h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
     <p>
          The main objective of HSDC is to produce Certified Seed of Cereals,
          Pulses, Oil Seeds & vegetables Seeds to meet out the requirement of
          farmers of Haryana in consultation with the Department of Agriculture,
          Haryana. The activities being adopted at Head Office level and as well
          as field level are given as under :
        </p>

        <ol>
          <li>
            <h5 className="mt-2">
              PLANNING OF SEED PRODUCTION PROGRAMME AT HEAD OFFICE LEVEL
            </h5>

            <p>
              The targets of Seed Production Programme are fixed on the basis of
              demand of certified seed to be sold during next year. The
              requirement of certified seed to be sold within State or outside
              State is assessed by Marketing Section of HSDC as well as
              Department of Agriculture, Haryana. On the basis of data provided
              by them, the requirement of certified seed for ensuing season and
              the projections for Seed Production Programme for the next three
              years are intimated to State Seed Production Committee of Haryana,
              which after considering the State demand recommends the Production
              Programme which is also informed to Board of Directors.
            </p>
            <p>
              The requirement of Breeder Seed is worked out and the same (as
              advance indent) is submitted to Govt. of India through Director
              General Agriculture, Haryana. The Breeder seed of State varieties
              is produced by CCS HAU, Govt. of India through ICAR and other
              Research Institutes planned to produce Breeder seed of National
              varieties. The Breeder seed produced are allocated by Govt. of
              India to the indenter. The allotted Breeder seeds is lifted either
              by HSDC or Haryana Agriculture University for Production of
              Foundation Seeds, as per requirement of HSDC to take Seed
              Production Programme in subsequent years. The Foundation Seed
              requirement for the next year is intimated to HAU for production
              at their farms and HAU meets the Foundation Seed requirement of
              HSDC as per indent. Hence, the work like total requirement of
              Breeder and Foundation seed, placing indent to Govt. of India and
              Haryana Agriculture University (for State varieties), arrangement
              of lifting Breeder and Foundation Seeds and further multiplication
              after fixing the targets for all the regional units of HSDC is
              being looked after at Head Office level by Seed Section.
            </p>
            <h6>
              Planning of Rabi Seeds Production Programme for the Next Three
              Years.
            </h6>
            <div className='table-responsive'>
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td colspan="7">
                    <strong>
                      PROPOSED SEED PRODUCTION PROGRAMME FOR RABI CROPS FOR NEXT
                      THREE YEARS IS AS UNDER:-
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <strong>(Qty. in qtls.)</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>S.No.</strong>
                  </td>
                  <td>
                    <strong>Crop</strong>
                  </td>
                  <td>
                    <strong>Variety</strong>
                  </td>
                  <td>
                    <strong>Rabi 2022-23</strong>
                  </td>
                  <td>
                    <strong>Rabi 2023-24</strong>
                  </td>
                  <td>
                    <strong>Rabi 2024-25</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="11">1</td>
                  <td rowspan="11">Wheat</td>
                  <td>DBW-90</td>
                  <td>2000.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                </tr>
                <tr>
                  <td>WH-1105</td>
                  <td>20000.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                </tr>
                <tr>
                  <td>DBW-187</td>
                  <td>60000.00</td>
                  <td>60000.00</td>
                  <td>60000.00</td>
                </tr>
                <tr>
                  <td>WH-1124</td>
                  <td>4500.00</td>
                  <td>5000.00</td>
                  <td>5000.00</td>
                </tr>
                <tr>
                  <td>HD-3086</td>
                  <td>30000.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                </tr>
                <tr>
                  <td>WH-1184</td>
                  <td>15000.00</td>
                  <td>25000.00</td>
                  <td>25000.00</td>
                </tr>
                <tr>
                  <td>PBW-725</td>
                  <td>18000.00</td>
                  <td>20000.00</td>
                  <td>20000.00</td>
                </tr>
                <tr>
                  <td>DBW-222</td>
                  <td>85000.00</td>
                  <td>90000.00</td>
                  <td>90000.00</td>
                </tr>
                <tr>
                  <td>DBW-303</td>
                  <td>40000.00</td>
                  <td>50000.00</td>
                  <td>50000.00</td>
                </tr>
                <tr>
                  <td>New Variety</td>
                  <td>35000.00</td>
                  <td>60000.00</td>
                  <td>60000.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Sub-Total</strong>
                  </td>
                  <td>
                    <strong>309500.00</strong>
                  </td>
                  <td>
                    <strong>310000.00</strong>
                  </td>
                  <td>
                    <strong>310000.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="4">2</td>
                  <td rowspan="4">Gram</td>
                  <td>GNG-1581</td>
                  <td>100.00</td>
                  <td>100.00</td>
                  <td>100.00</td>
                </tr>
                <tr>
                  <td>AMAN-515</td>
                  <td>500.00</td>
                  <td>400.00</td>
                  <td>400.00</td>
                </tr>
                <tr>
                  <td>New Variety</td>
                  <td>400.00</td>
                  <td>500.00</td>
                  <td>500.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Sub-Total</strong>
                  </td>
                  <td>
                    <strong>1000.00</strong>
                  </td>
                  <td>
                    <strong>1000.00</strong>
                  </td>
                  <td>
                    <strong>1000.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="5">3</td>
                  <td rowspan="5">Mustard</td>
                  <td>RH-749</td>
                  <td>300.00</td>
                  <td>300.00</td>
                  <td>300.00</td>
                </tr>
                <tr>
                  <td>RH-761</td>
                  <td>100.00</td>
                  <td>100.00</td>
                  <td>100.00</td>
                </tr>
                <tr>
                  <td>RH-725</td>
                  <td>200.00</td>
                  <td>250.00</td>
                  <td>250.00</td>
                </tr>
                <tr>
                  <td>NEW VARIETY</td>
                  <td>100.00</td>
                  <td>100.00</td>
                  <td>100.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Sub-Total</strong>
                  </td>
                  <td>
                    <strong>700.00</strong>
                  </td>
                  <td>
                    <strong>750.00</strong>
                  </td>
                  <td>
                    <strong>750.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="4">4</td>
                  <td rowspan="4">Barley</td>
                  <td>DWRUB</td>
                  <td>400.00</td>
                  <td>500.00</td>
                  <td>500.00</td>
                </tr>
                <tr>
                  <td>BH-946</td>
                  <td>400.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                </tr>
                <tr>
                  <td>NEW VARIETY</td>
                  <td>300.00</td>
                  <td>500.00</td>
                  <td>500.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Sub-Total</strong>
                  </td>
                  <td>
                    <strong>1100.00</strong>
                  </td>
                  <td>
                    <strong>1000.00</strong>
                  </td>
                  <td>
                    <strong>1000.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">5</td>
                  <td rowspan="1">Lentil</td>
                  <td>New Variety</td>
                  <td>20.00</td>
                  <td>20.00</td>
                  <td>20.00</td>
                </tr>
                <tr>
                  <td rowspan="1">6</td>
                  <td rowspan="1">Barseem</td>
                  <td>New Variety</td>
                  <td>200.00</td>
                  <td>250.00</td>
                  <td>250.00</td>
                </tr>
                <tr>
                  <td rowspan="1">7</td>
                  <td rowspan="1">Oat</td>
                  <td>New Variety</td>
                  <td>200.00</td>
                  <td>250.00</td>
                  <td>250.00</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <strong>G.Total</strong>
                  </td>
                  <td>
                    <strong>312720.00</strong>
                  </td>
                  <td>
                    <strong>313270.00</strong>
                  </td>
                  <td>
                    <strong>313270.00</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div className='table-responsive'>
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td colspan="7">
                    <strong>
                      PROPOSED SEED PRODUCTION PLAN OF KHARIF CROP FOR NEXT
                      THREE YEARS I.E.
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <strong>(Qty.in qtls.)</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>S.No.</strong>
                  </td>
                  <td>
                    <strong>Crop</strong>
                  </td>
                  <td>
                    <strong>Variety</strong>
                  </td>
                  <td>
                    <strong>Kharif-2022</strong>
                  </td>
                  <td>
                    <strong>Kharif-2023</strong>
                  </td>
                  <td>
                    <strong>Kharif-2024</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="14">1</td>
                  <td rowspan="14">Paddy</td>
                  <td>PB-1509</td>
                  <td>1025.00</td>
                  <td>1095.00</td>
                  <td>1015.00</td>
                </tr>
                <tr>
                  <td>CSR-30</td>
                  <td>205.00</td>
                  <td>275.00</td>
                  <td>265.00</td>
                </tr>
                <tr>
                  <td>PUSA-1121</td>
                  <td>810.00</td>
                  <td>800.00</td>
                  <td>810.00</td>
                </tr>
                <tr>
                  <td>PB-1401</td>
                  <td>120.00</td>
                  <td>120.00</td>
                  <td>120.00</td>
                </tr>
                <tr>
                  <td>PB-1</td>
                  <td>130.00</td>
                  <td>130.00</td>
                  <td>130.00</td>
                </tr>
                <tr>
                  <td>PR-114</td>
                  <td>720.00</td>
                  <td>660.00</td>
                  <td>660.00</td>
                </tr>
                <tr>
                  <td>PR-126</td>
                  <td>480.00</td>
                  <td>280.00</td>
                  <td>280.00</td>
                </tr>
                <tr>
                  <td>PR-121</td>
                  <td>130.00</td>
                  <td>130.00</td>
                  <td>130.00</td>
                </tr>
                <tr>
                  <td>PR-128</td>
                  <td>100.00</td>
                  <td>210.00</td>
                  <td>200.00</td>
                </tr>
                <tr>
                  <td>PR-129</td>
                  <td>315.00</td>
                  <td>315.00</td>
                  <td>320.00</td>
                </tr>
                <tr>
                  <td>PB-1718</td>
                  <td>200.00</td>
                  <td>200.00</td>
                  <td>200.00</td>
                </tr>
                <tr>
                  <td>PUSA-1692</td>
                  <td>240.00</td>
                  <td>210.00</td>
                  <td>210.00</td>
                </tr>
                <tr>
                  <td>HKR-47</td>
                  <td>125.00</td>
                  <td>120.00</td>
                  <td>120.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>4600.00</strong>
                  </td>
                  <td>
                    <strong>4545.00</strong>
                  </td>
                  <td>
                    <strong>4460.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="5">2</td>
                  <td rowspan="5">Moong</td>
                  <td>SML-668</td>
                  <td>170.00</td>
                  <td>170.00</td>
                  <td>170.00</td>
                </tr>
                <tr>
                  <td>MH-421</td>
                  <td>230.00</td>
                  <td>230.00</td>
                  <td>240.00</td>
                </tr>
                <tr>
                  <td>Satya</td>
                  <td>80.00</td>
                  <td>80.00</td>
                  <td>80.00</td>
                </tr>
                <tr>
                  <td>MH-1270</td>
                  <td>70.00</td>
                  <td>70.00</td>
                  <td>90.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>550.00</strong>
                  </td>
                  <td>
                    <strong>550.00</strong>
                  </td>
                  <td>
                    <strong>580.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="4">3</td>
                  <td rowspan="4">Gaur</td>
                  <td>HG-563</td>
                  <td>390.00</td>
                  <td>338.00</td>
                  <td>400.00</td>
                </tr>
                <tr>
                  <td>HG2-20</td>
                  <td>440.00</td>
                  <td>295.00</td>
                  <td>300.00</td>
                </tr>
                <tr>
                  <td>HG-3650</td>
                  <td>165.00</td>
                  <td>167.00</td>
                  <td>160.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>995.00</strong>
                  </td>
                  <td>
                    <strong>800.00</strong>
                  </td>
                  <td>
                    <strong>860.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="2">4</td>
                  <td rowspan="2">Bajra</td>
                  <td>HHB-67</td>
                  <td>335.00</td>
                  <td>207.00</td>
                  <td>242.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>335.00</strong>
                  </td>
                  <td>
                    <strong>207.00</strong>
                  </td>
                  <td>
                    <strong>242.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="2">5</td>
                  <td rowspan="2">Arhar</td>
                  <td>Manak</td>
                  <td>85.00</td>
                  <td>60.00</td>
                  <td>63.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>85.00</strong>
                  </td>
                  <td>
                    <strong>60.00</strong>
                  </td>
                  <td>
                    <strong>63.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="3">6</td>
                  <td rowspan="3">Mash</td>
                  <td>479</td>
                  <td>35.00</td>
                  <td>35.00</td>
                  <td>35.00</td>
                </tr>
                <tr>
                  <td>PDU-1</td>
                  <td>1.00</td>
                  <td>1.00</td>
                  <td>1.00</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>36.00</strong>
                  </td>
                  <td>
                    <strong>36.00</strong>
                  </td>
                  <td>
                    <strong>36.00</strong>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">7</td>
                  <td rowspan="1">Til</td>
                  <td>HT-1</td>
                  <td>18.00</td>
                  <td>18.00</td>
                  <td>17.00</td>
                </tr>
              </tbody>
            </table>
            </div>
          </li>
          <li>
            <h5 className="mt-2">SEED PRODUCTION AT FIELD LEVEL</h5>
            <p>
              The allotment of Seed Production Programme of given targets is
              achieved by Field units by allotting the Foundation Seeds to the
              seed growers through technical staff in the compact areas. The
              seed production is conducted through contract seed gropwers that
              may be shareholder and non-shareholder growers. A list of seed
              growers (registered under Seed Production Program) containing all
              the information of growers and seed supplied to them is submitted
              to Haryana State Seed Certification Agency for the purpose of
              field inspection. As per provision contained in the Seed Act,
              1966, the State Seed Certification Agency conducts inspection of
              the fields of the growers to ensure the quality of the seed. The
              technical staff of the Corporation also carry out the inspection
              of the seed fields of the growers at two different stages i.e.
              flowering stage and at the time of maturity of the crop. During
              these inspections, the field staff provides guidelines to the seed
              growers as to how to maintain their seed plots' isolation for
              genetic purity, free them from weed plants other crop plants and
              diseases etc. Although estimated yield given by Haryana State Seed
              Certification Agency representative is considered for receipt of
              raw seed yet maximum norms of raw seed yield per acre fixed by
              HSDC are also kept in mind. From Rabi 2021-22 Seed Production
              Programme has been allotted through Uttam Beej Portal as per
              guidelines of Agriculture & Farmers Welfare Department and Haryana
              State Seed Certification Agency (HSSCA).
            </p>
          </li>
        </ol>
      </div>
    </div>
  )
}

export default SeedProduction
